import { UserIdentity } from "~/api/Api";

import { SiteIntegrationWithAuthorizations } from "../withAuthorizations";
import { IntegrationContainer } from "./IntegrationContainer";
import styles from "./SiteIntegrations.module.scss";

export const SiteIntegrations = ({
  siteId,
  identities,
  integrations,
}: {
  siteId: number;
  identities: UserIdentity[];
  integrations: SiteIntegrationWithAuthorizations[];
}) => {
  const analyticsIntegration = integrations.find(
    (integration) => integration.record.kind === "google_analytics",
  );

  const searchConsoleIntegration = integrations.find(
    (integration) => integration.record.kind === "google_search_console",
  );

  return (
    <div className={styles.root}>
      <IntegrationContainer
        title="Google Analytics Integration"
        kind="google_analytics"
        integration={analyticsIntegration}
        siteId={siteId}
        identities={identities}
      />

      <IntegrationContainer
        title="Google Search Console Integration"
        kind="google_search_console"
        integration={searchConsoleIntegration}
        siteId={siteId}
        identities={identities}
      />
    </div>
  );
};
